import { useCallback, useMemo } from "react";

import type { VoucherNewItem_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import * as Shared from "../../../_shared";
import * as Converter from "../converter";
import { useHandleTransition } from "./use-handle-transition";
import { useVoucherCreate } from "./use-update";

type Props = {
	hotelID: string;
	queryData: VoucherNewItem_EditPageQuery;
};

export const useInitialized = ({ hotelID, queryData }: Props) => {
	const inputModel = useMemo(() => Converter.serverModelToInputModelConverter({ queryData }), [queryData]);

	const { viewModel, onSetViewModel, onResetViewModel } = Shared.Model.FormModel.useFormModel({
		inputModel,
	});

	const { onTransitionToVoucherList } = useHandleTransition({ hotelID });
	const onSuccessCallback = useCallback(() => {
		onResetViewModel();
		/**
		 * viewModel/isDirty をキーに画面遷移のブロックをしているので、明示的に指定数秒後に遷移する
		 */
		setTimeout(() => onTransitionToVoucherList(), 1000);
	}, [onResetViewModel, onTransitionToVoucherList]);
	const { onVoucherCreate } = useVoucherCreate({
		viewModel,
		onSuccessCallback,
	});

	return {
		viewModel,
		onSetViewModel,
		//
		onVoucherCreate,
	};
};
